// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PolazniciPregled_container__nPvmk {
  display: flex;
  flex-direction: column;
}
.PolazniciPregled_headingContainer__ECTGr {
  width: 50%;
  align-content: center;
  gap: 24px;
}

.PolazniciPregled_badge__dAMOG {
  align-items: center;
  background-color: #87ad76;
  border-radius: 4px;
  display: flex;
  padding: 6px 12px;
}
.PolazniciPregled_badgeText__qKduY {
  color: #ffffff;
  cursor: default;
}
.PolazniciPregled_groupBadgeText__GDypD,
.PolazniciPregled_badgeText__qKduY {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px;
}

.PolazniciPregled_headingContainer__ECTGr,
.PolazniciPregled_headingProgramBadge__Z0jdv,
.PolazniciPregled_backToContainer__Varx-,
.PolazniciPregled_evidencijaBtn__ySJYu,
.PolazniciPregled_content__amx6D,
.PolazniciPregled_urediBtn__zqRWp {
  display: flex;
  align-items: center;
}
.PolazniciPregled_headingButtonContainer__ll-dJ {
  display: flex;
  gap: 4px;
  z-index: 100;
}
.PolazniciPregled_background__IHsYK {
  height: 200px;
  width: 100%;
  border-radius: 10px;
  background-color: #ebe6dd;
  margin-top: 20px;
}
.PolazniciPregled_imageContainer__fOwFn {
  width: 213px;
  height: 170px;
  border-radius: 4px;
  border: 8px solid #ffffff;
  background-size: cover;
  background-position: center;
  margin-top: -150px;
  margin-left: 50px;
  position: relative;
}
.PolazniciPregled_headingProgramBadge__Z0jdv {
  padding: 6px 12px;
  gap: 4px;
  border-radius: 4px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.014px;
  height: 29px;
  background: #87ad76;
  color: #ffffff;
}
.PolazniciPregled_backToContainer__Varx- {
  gap: 6px;
  width: fit-content;
  cursor: pointer;
}
.PolazniciPregled_backToh1__-vUe6 {
  font-size: 16px;
  line-height: 22px;
  color: #5f6d7e;
}
.PolazniciPregled_backToh1__-vUe6,
.PolazniciPregled_heading__smnDK,
.PolazniciPregled_span__DCpBI,
.PolazniciPregled_spanData__I9IE5,
.PolazniciPregled_evidencijaBtn__ySJYu,
.PolazniciPregled_groupH1__jW2tA,
.PolazniciPregled_addToGroupBtn__NU3Bc,
.PolazniciPregled_deleteBtn__D9gcl,
.PolazniciPregled_urediBtn__zqRWp {
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
  text-align: left;
}
.PolazniciPregled_heading__smnDK {
  font-size: 28px;
  line-height: 34px;
  color: #4d4e4e;
  margin-left: 1%;
  width: fit-content;
}
.PolazniciPregled_groupsBadges__O1xTi {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.PolazniciPregled_groupBadgeText__GDypD,
.PolazniciPregled_badgeText__qKduY {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.PolazniciPregled_groupBadge__ToXmo {
  background-color: #f4f4f4;
  border-radius: 20px;
  padding: 8px;
}
.PolazniciPregled_groupBadgeText__GDypD {
  color: #4d4d4d;
  cursor: default;
}
.PolazniciPregled_columns__y9sTv {
  width: 100%;
}
.PolazniciPregled_columns__y9sTv,
.PolazniciPregled_left-column__x7Hxx,
.PolazniciPregled_right-column__1ZhFn {
  display: flex;
}
.PolazniciPregled_left-column__x7Hxx {
  flex: 70% 1;
  padding: 10px;
}
.PolazniciPregled_right-column__1ZhFn {
  flex: 30% 1;
  padding: 10px;
  margin-top: -100px;
  padding-left: 100px;
  width: max-content;
  z-index: 100;
  background-color: white;
}
.PolazniciPregled_sub-column__Gvm9j {
  width: 40%;
}
.PolazniciPregled_span__DCpBI {
  margin: 3px;
  padding: 5px;
  font-size: 16px;
  line-height: 22px;
  color: #4d4d4d;
}
.PolazniciPregled_spanData__I9IE5 {
  margin: 3px;
  padding: 5px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #7e818c;
}
.PolazniciPregled_evidencijaBtn__ySJYu,
.PolazniciPregled_urediBtn__zqRWp {
  height: 52px;
  background: #cb9c2d;
  border: none;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  justify-content: space-around;
}
.PolazniciPregled_evidencijaBtn__ySJYu,
.PolazniciPregled_addToGroupBtn__NU3Bc,
.PolazniciPregled_urediBtn__zqRWp {
  width: 228px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  cursor: pointer;
}
.PolazniciPregled_evidencijaBtn__ySJYu:hover {
  background-color: #a07b26;
}
.PolazniciPregled_content__amx6D {
  flex-direction: column;
}
.PolazniciPregled_groupContent__UUM3b {
  margin-top: 10%;
  gap: 6px;
  margin-bottom: 24px;
}
.PolazniciPregled_groupH1__jW2tA {
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #4d4e4e;
}
.PolazniciPregled_groupContent__UUM3b,
.PolazniciPregled_iconContainerm__qNQYq,
.PolazniciPregled_addToGroupBtn__NU3Bc {
  display: flex;
  justify-content: center;
}
.PolazniciPregled_iconContainer__tiWJM {
  margin-top: 10%;
}
.PolazniciPregled_groupText__itC3V {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: center;
  color: #5f6d7e;
  width: 80%;
  margin-top: 1%;
}
.PolazniciPregled_addToGroupBtn__NU3Bc {
  height: 40px;
  border: 1px solid #d1d9e2;
  background-color: white;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: #5f6d7e;
  margin-top: 10%;
}

.PolazniciPregled_addToGroupBtn__NU3Bc:hover {
  transition: background-color 300ms;
  background-color: rgb(218, 217, 217);
}
table {
  width: 90%;
  border-collapse: separate;
  border-spacing: 0 20px;
}
td.PolazniciPregled_span__DCpBI {
  width: 10%;
}
td.PolazniciPregled_spanData__I9IE5 {
  width: 15%;
}
.PolazniciPregled_deleteBtn__D9gcl {
  background-color: #cb2d2d;
  color: #ffffff;
  border-radius: 4px;
  border: none;
  padding: 8px 16px 8px 16px;
  height: 52px;
  width: 100%;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
}
.PolazniciPregled_deleteBtn__D9gcl:hover {
  opacity: 0.89;
}

.PolazniciPregled_urediBtn__zqRWp {
  background-color: #fff;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  margin-bottom: 15px;
  color: #5f6d7e;
  border: 1px solid #d1d9e2;
}

.PolazniciPregled_urediBtn__zqRWp:hover {
  background-color: rgb(240, 240, 240);
}
`, "",{"version":3,"sources":["webpack://./src/scenes/polazniciPregled/PolazniciPregled.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;;;;;;EASE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;;;EAGE,aAAa;AACf;AACA;EACE,WAAS;EACT,aAAa;AACf;AACA;EACE,WAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;AACA;;;EAGE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,oDAAoD;EACpD,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n.headingContainer {\n  width: 50%;\n  align-content: center;\n  gap: 24px;\n}\n\n.badge {\n  align-items: center;\n  background-color: #87ad76;\n  border-radius: 4px;\n  display: flex;\n  padding: 6px 12px;\n}\n.badgeText {\n  color: #ffffff;\n  cursor: default;\n}\n.groupBadgeText,\n.badgeText {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n\n.headingContainer,\n.headingProgramBadge,\n.backToContainer,\n.evidencijaBtn,\n.content,\n.urediBtn {\n  display: flex;\n  align-items: center;\n}\n.headingButtonContainer {\n  display: flex;\n  gap: 4px;\n  z-index: 100;\n}\n.background {\n  height: 200px;\n  width: 100%;\n  border-radius: 10px;\n  background-color: #ebe6dd;\n  margin-top: 20px;\n}\n.imageContainer {\n  width: 213px;\n  height: 170px;\n  border-radius: 4px;\n  border: 8px solid #ffffff;\n  background-size: cover;\n  background-position: center;\n  margin-top: -150px;\n  margin-left: 50px;\n  position: relative;\n}\n.headingProgramBadge {\n  padding: 6px 12px;\n  gap: 4px;\n  border-radius: 4px;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.014px;\n  height: 29px;\n  background: #87ad76;\n  color: #ffffff;\n}\n.backToContainer {\n  gap: 6px;\n  width: fit-content;\n  cursor: pointer;\n}\n.backToh1 {\n  font-size: 16px;\n  line-height: 22px;\n  color: #5f6d7e;\n}\n.backToh1,\n.heading,\n.span,\n.spanData,\n.evidencijaBtn,\n.groupH1,\n.addToGroupBtn,\n.deleteBtn,\n.urediBtn {\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.heading {\n  font-size: 28px;\n  line-height: 34px;\n  color: #4d4e4e;\n  margin-left: 1%;\n  width: fit-content;\n}\n.groupsBadges {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n.groupBadgeText,\n.badgeText {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.groupBadge {\n  background-color: #f4f4f4;\n  border-radius: 20px;\n  padding: 8px;\n}\n.groupBadgeText {\n  color: #4d4d4d;\n  cursor: default;\n}\n.columns {\n  width: 100%;\n}\n.columns,\n.left-column,\n.right-column {\n  display: flex;\n}\n.left-column {\n  flex: 70%;\n  padding: 10px;\n}\n.right-column {\n  flex: 30%;\n  padding: 10px;\n  margin-top: -100px;\n  padding-left: 100px;\n  width: max-content;\n  z-index: 100;\n  background-color: white;\n}\n.sub-column {\n  width: 40%;\n}\n.span {\n  margin: 3px;\n  padding: 5px;\n  font-size: 16px;\n  line-height: 22px;\n  color: #4d4d4d;\n}\n.spanData {\n  margin: 3px;\n  padding: 5px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  color: #7e818c;\n}\n.evidencijaBtn,\n.urediBtn {\n  height: 52px;\n  background: #cb9c2d;\n  border: none;\n  font-size: 15px;\n  line-height: 22px;\n  text-align: center;\n  color: #ffffff;\n  justify-content: space-around;\n}\n.evidencijaBtn,\n.addToGroupBtn,\n.urediBtn {\n  width: 228px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  cursor: pointer;\n}\n.evidencijaBtn:hover {\n  background-color: #a07b26;\n}\n.content {\n  flex-direction: column;\n}\n.groupContent {\n  margin-top: 10%;\n  gap: 6px;\n  margin-bottom: 24px;\n}\n.groupH1 {\n  font-size: 20px;\n  line-height: 24px;\n  text-align: center;\n  color: #4d4e4e;\n}\n.groupContent,\n.iconContainerm,\n.addToGroupBtn {\n  display: flex;\n  justify-content: center;\n}\n.iconContainer {\n  margin-top: 10%;\n}\n.groupText {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: #5f6d7e;\n  width: 80%;\n  margin-top: 1%;\n}\n.addToGroupBtn {\n  height: 40px;\n  border: 1px solid #d1d9e2;\n  background-color: white;\n  font-size: 16px;\n  line-height: 22px;\n  text-align: left;\n  color: #5f6d7e;\n  margin-top: 10%;\n}\n\n.addToGroupBtn:hover {\n  transition: background-color 300ms;\n  background-color: rgb(218, 217, 217);\n}\ntable {\n  width: 90%;\n  border-collapse: separate;\n  border-spacing: 0 20px;\n}\ntd.span {\n  width: 10%;\n}\ntd.spanData {\n  width: 15%;\n}\n.deleteBtn {\n  background-color: #cb2d2d;\n  color: #ffffff;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 16px 8px 16px;\n  height: 52px;\n  width: 100%;\n  font-size: 15px;\n  line-height: 22px;\n  text-align: center;\n  cursor: pointer;\n}\n.deleteBtn:hover {\n  opacity: 0.89;\n}\n\n.urediBtn {\n  background-color: #fff;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  margin-bottom: 15px;\n  color: #5f6d7e;\n  border: 1px solid #d1d9e2;\n}\n\n.urediBtn:hover {\n  background-color: rgb(240, 240, 240);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PolazniciPregled_container__nPvmk`,
	"headingContainer": `PolazniciPregled_headingContainer__ECTGr`,
	"badge": `PolazniciPregled_badge__dAMOG`,
	"badgeText": `PolazniciPregled_badgeText__qKduY`,
	"groupBadgeText": `PolazniciPregled_groupBadgeText__GDypD`,
	"headingProgramBadge": `PolazniciPregled_headingProgramBadge__Z0jdv`,
	"backToContainer": `PolazniciPregled_backToContainer__Varx-`,
	"evidencijaBtn": `PolazniciPregled_evidencijaBtn__ySJYu`,
	"content": `PolazniciPregled_content__amx6D`,
	"urediBtn": `PolazniciPregled_urediBtn__zqRWp`,
	"headingButtonContainer": `PolazniciPregled_headingButtonContainer__ll-dJ`,
	"background": `PolazniciPregled_background__IHsYK`,
	"imageContainer": `PolazniciPregled_imageContainer__fOwFn`,
	"backToh1": `PolazniciPregled_backToh1__-vUe6`,
	"heading": `PolazniciPregled_heading__smnDK`,
	"span": `PolazniciPregled_span__DCpBI`,
	"spanData": `PolazniciPregled_spanData__I9IE5`,
	"groupH1": `PolazniciPregled_groupH1__jW2tA`,
	"addToGroupBtn": `PolazniciPregled_addToGroupBtn__NU3Bc`,
	"deleteBtn": `PolazniciPregled_deleteBtn__D9gcl`,
	"groupsBadges": `PolazniciPregled_groupsBadges__O1xTi`,
	"groupBadge": `PolazniciPregled_groupBadge__ToXmo`,
	"columns": `PolazniciPregled_columns__y9sTv`,
	"left-column": `PolazniciPregled_left-column__x7Hxx`,
	"right-column": `PolazniciPregled_right-column__1ZhFn`,
	"sub-column": `PolazniciPregled_sub-column__Gvm9j`,
	"groupContent": `PolazniciPregled_groupContent__UUM3b`,
	"iconContainerm": `PolazniciPregled_iconContainerm__qNQYq`,
	"iconContainer": `PolazniciPregled_iconContainer__tiWJM`,
	"groupText": `PolazniciPregled_groupText__itC3V`
};
export default ___CSS_LOADER_EXPORT___;
